import { Type, Transform, Exclude } from 'class-transformer';
import { IsString, IsNotEmpty, IsNumber, IsDate, IsOptional, IsInt, IsArray, IsBoolean } from 'class-validator';
import { CompanyDto } from './company.dto';
import { UserDto } from './user.dto';
import { DownloadFileDto } from './download-file.dto';
import { CityInfoDto } from './geo/city';
import { MediaTypeBaseDataDto } from './media-type.dto';
import { EventDto } from './events.dto';
import { CreateContactsDto } from './contacts';
import { LeadSourceDirection, LeadSourceType } from './enums/leads';

export class LeadInfoDto {
  source2Id?: number | null;
  source2Name?: string | null;
  @IsNumber()
    id: number;

  @IsString()
  @IsNotEmpty()
    subject: string;

  @Type(() => LeadStatusDto)
    status: LeadStatusDto;

  @Type(() => LeadBudgetDto)
    budget: LeadBudgetDto;

  @Type(() => LeadQualityDto)
    quality: LeadQualityDto;

  manager?: UserDto;

  meta?: Array<Record<string, number>>;

  @Type(() => CompanyDto)
    company: CompanyDto;

  @Type(() => Array<CompanyDto>)
    companies?: CompanyDto[];

  @IsDate()
  @Type(() => Date)
    createdAt: Date;

  sourceType?: LeadSourceType;

  sourceValue?: string;

  sourceDirection?: LeadSourceDirection | null;
}

export class CreateLeadDto {
  @IsString()
  @IsNotEmpty()
    subject: string;

  // @Type(() => Number)
  statusId: number;

  @IsString()
  @IsNotEmpty()
    content: string;

  budgetId?: number;

  @IsNumber()
  @IsOptional()
    qualityId?: number;

  emailId?: number;

  atsEntryId?: string;

  sourceType?: LeadSourceType;

  sourceValue?: string;

  @Transform((value) => {
    return value.value <= 0 ? undefined : value;
  })
  @IsNumber()
  @IsOptional()
    userId?: number;

  @Type(() => CreateContactsDto)
    contacts?: CreateContactsDto;
}

export class UpdateLeadPropsDto {
  id: number;
  budgetId?: number;
  qualityId?: number;
}

export class LeadDto extends CreateLeadDto {
  source2Id?: number | null;
  source2Name?: string | null;
  id: number;
  speechToTextEnabled?: boolean;
  transcription?: string;
  transcriptionStatus?: string;
  status: LeadStatusDto;
  budget: LeadBudgetDto;
  quality: LeadQualityDto;
  company: CompanyDto;

  @IsDate()
  @Type(() => Date)
    createdAt: Date;

  @Type(() => Array<CompanyDto>)
    companies?: CompanyDto[];

  manager?: UserDto;
  events: EventDto[];

  sourceDirection?: LeadSourceDirection | null;
}

export class LeadStatusDto {
  id: number;
  label: string;
}

export class LeadBudgetDto {
  id: number;
  label: string;
}

export class LeadQualityDto {
  id: number;
  label: string;
}

export class LeadMediaplanDto {
  id: number;
  cityId: number | null;
  city: CityInfoDto | null;
  mediaTypeId: number | null;
  mediaType: MediaTypeBaseDataDto | null;
  offerFile: DownloadFileDto | null;
  mediaplanSum: number | null;
  createdBy: UserDto | null;
  createdAt: string;
}

export class LeadMediaplanFilter {
  @IsOptional()
  @IsInt()
    cityId?: number;

  @IsOptional()
  @IsInt()
    mediaTypeId?: number;
}

export class UpdateLeadMediaplanDto {
  cityId: number | null;
  mediaTypeId: number | null;
  mediaplanSum: number | null;
  offerFile: DownloadFileDto | null;
}

export class LeadBulkUpdateDto {
  @IsOptional()
  @IsArray()
    ids?: number[];

  @IsOptional()
  @IsArray()
    excludedIds?: number[];

  @IsOptional()
  @IsBoolean()
    all?: boolean;

  @IsOptional()
  @IsString()
    filter?: string;

  @IsOptional()
    budgetId?: number;

  @IsOptional()
    qualityId?: number;

  @IsOptional()
    statusId?: number;

  @IsOptional()
    managerId?: number;
}

export class LeadBulkUpdateResultDto {
  @IsNumber()
    targetCount: number;

  @IsNumber()
    updatedCount: number;
}

export type LeadLiveArea = 'lead' | 'comments' | 'contacts' | 'audit';
export type LeadLiveChangeDto = { leadId: number; areas: LeadLiveArea[] };
export const LEAD_LIVE_CHANGED = 'lead:changed';
export const LEAD_LIVE_SUBSCRIBE = 'lead:subscribe';
export const LEAD_LIVE_UNSUBSCRIBE = 'lead:unsubscribe';
export const LEAD_LIVE_UNAVAILABLE = 'lead:unavailable';
